import axios from 'axios'
import { BUSCAR_ULTIMOS_HISTORICOS_PRECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarUltimosHistoricosPreco (precoId, empresaId) {
  let url = `${URL}/preco/${precoId}/empresa/${empresaId}/historicos`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ULTIMOS_HISTORICOS_PRECO,
        payload: response

      })
  );
}
